import { RRule } from 'rrule';
import type { ScheduleChange } from './contracts';
import { formatEventRange } from './date-format';
export function scheduleNotice(change: ScheduleChange) {
  const label =
    change.scope === 'occurrence'
      ? 'This occurrence was rescheduled'
      : change.scope === 'following'
        ? 'Following series schedule changed'
        : change.previous.recurrence || change.current.recurrence
          ? 'Series schedule changed'
          : 'Event rescheduled';
  const describe = (schedule: ScheduleChange['previous']) =>
    `${formatEventRange(schedule)} (${schedule.timezone})${schedule.recurrence ? `; ${repeatDescription(schedule.recurrence)}` : ''}`;
  return { label, previous: describe(change.previous), current: describe(change.current) };
}

function repeatDescription(rule: string) {
  try {
    return RRule.fromString(rule).toText();
  } catch {
    return 'Custom repeating schedule';
  }
}
